import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form, FormGroup, Input, InputGroup, Button } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import withIntl from '../../../../components/Intl/WithIntl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Impor Actions
import { editConversationRequest, addMessageRequest, isUserInConversationParticipants, CONVERSATION_STATUS_OPEN, getConversationMessagesRequest } from '../../ConversationActions';
import { getSessionOption } from '../../../Session/SessionActions';
import { getCurrentApplicant, sendApplicantNeedAttention } from '../../../Applicant/ApplicantActions';
import { sendSocket } from '../../../App/AppActions';

class MessageAddForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            content: '',
            isSending: false,
            isJoining: false,
        };
    }

    componentDidMount() {
        this.setInputFocus();
    }

    componentWillUpdate(nextProps, nextState) {
        if(this.state.content === '' && nextState.content !== '') {
            this.props.dispatch(sendSocket({ type: 'conversation/message/writting', data: { user: { _id: this.props.user._id, firstName: this.props.user.firstName }, conversation: this.props.conversation?._id, isWritting: true } }));
        } else if(this.state.content !== '' && nextState.content === '') {
            this.props.dispatch(sendSocket({ type: 'conversation/message/writting', data: { user: { _id: this.props.user._id, firstName: this.props.user.firstName }, conversation: this.props.conversation?._id, isWritting: false } }));
        }

        if(nextProps.isFocus) {
            this.setInputFocus();
        }
    }

    setInputFocus() {
        // console.log('MessageAddForm::: setInputFocus', this.wrapper, this.wrapper && this.wrapper.getElementsByTagName('input'));
        this.wrapper && this.wrapper.getElementsByTagName('input')[0].focus();
    }

    isSending() {
        return this.state.isSending;
    }

    handleChange = event => {
        this.setState({
            content: event.target.value,
        });
    };

    handleJoinConversation = event => {
        if(this.props.conversation && this.props.user && this.props.user.role !== 'student') {
            this.setState({
                isJoining: true,
            });
            this.props.dispatch(editConversationRequest({
                ...this.props.conversation,
                participants: [
                    ...this.props.conversation.participants,
                    this.props.user._id,
                ],
            })).then(conversation => {
                this.props.dispatch(getConversationMessagesRequest(this.props.conversation._id));
                this.setState({
                    isJoining: false,
                });
            });
        }
    };

    handleRemoveParticipation = event => {
        if(this.props.conversation && this.props.user && this.props.user.role !== 'student' && process.env.NODE_ENV === 'development') {
            this.setState({
                isJoining: true,
            });
            this.props.dispatch(editConversationRequest({
                ...this.props.conversation,
                participants: this.props.conversation.participants.filter(participant => (participant._id || participant) !== this.props.user._id),
            })).then(conversation => {
                this.setState({
                    isJoining: false,
                });
            });
        }
    };

    handleSubmit = event => {
        event.preventDefault();
        if(this.state.content) {
            this.setState({
                isSending: true,
            });
            this.props.dispatch(addMessageRequest({
                conversation: this.props.conversation && this.props.conversation._id ? this.props.conversation._id : null,
                text: this.state.content,
                type: this.props.isAdmin ? 'system' : 'user',
                author: this.props.user && this.props.user._id,
            })).then(result => {
                this.setState({
                    content: '',
                    isSending: false,
                }, () => {
                    this.setInputFocus();
                });
                if(this.props.currentApplicant && this.props.currentApplicant.session && getSessionOption(this.props.currentApplicant.session, 'isLiveQueue')) {
                    console.log('Send need attention::: conversation');
                    this.props.dispatch(sendApplicantNeedAttention(this.props.currentApplicant.session._id, this.props.currentApplicant._id, true, 'conversation'));
                }
            });
        }
        return false;
    };

    render() {
        if(this.props.conversation && this.props.conversation.status === CONVERSATION_STATUS_OPEN) {
            if(isUserInConversationParticipants(this.props.conversation, this.props.user)) {
                return (
                    <div ref={ref => { this.wrapper = ref; }}>
                        <Form onSubmit={this.handleSubmit}>
                            <InputGroup size="sm">
                                <Input
                                    type="text"
                                    name="content"
                                    value={this.state.content}
                                    placeholder={this.props.intl.messages.conversationInputLabel}
                                    onChange={this.handleChange}
                                    disabled={this.isSending()}
                                    autoComplete="true"
                                />

                                <Button color="info" disabled={this.isSending() || !this.state.content}>
                                    {this.isSending() ? <FontAwesomeIcon icon="spinner" spin /> : <FontAwesomeIcon icon="paper-plane" />}
                                </Button>
                                {process.env.NODE_ENV === 'development' && <Button size="sm" onClick={this.handleRemoveParticipation}>Remove participation</Button>}

                            </InputGroup>
                        </Form>
                    </div>
                );
            }
            if(this.props.user && this.props.user.role !== 'student') {
                return (
                    <div>
                        <Button color="info" block size="sm" onClick={this.handleJoinConversation} disabled={this.state.isJoining}>{this.state.isJoining ? <FontAwesomeIcon icon="spinner" spin /> : <FontAwesomeIcon icon="sign-in-alt" />} <FormattedMessage id="conversationJoinButton" defaultMessage="Join conversation" /></Button>
                    </div>
                );
            }
        }
        return null;
    }
}

function mapStateToProps(store, props) {
    return {
        user: store.users.user,
        currentApplicant: getCurrentApplicant(store),
    };
}

MessageAddForm.propTypes = {
    dispatch: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
    user: PropTypes.object,
    currentApplicant: PropTypes.object,
    conversation: PropTypes.object.isRequired,
    isAdmin: PropTypes.bool,
};

export default connect(mapStateToProps)(withIntl(MessageAddForm));
